import CameraIcon from './CameraIcons';

export default function CameraStatus({ status, error, onRetry }) {
  if (status === 'ready') return null;

  return <div className="plate-camera__state" role={error ? 'alert' : 'status'}>
    <CameraIcon name="camera" size={34} />
    <p>{status === 'loading' ? 'در حال آماده‌سازی دوربین…' : error}</p>
    {status === 'error' && <button type="button" onClick={onRetry}>تلاش دوباره</button>}
  </div>;
}
